import { ProjectItemOption } from './../../../../../../../../sdk/models/project-item-option';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TASK_ASSIGN_EDIT_TABLE } from '../constant/task-assign-table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-editable-task',
  templateUrl: './editable-task.component.html',
  styleUrls: ['./editable-task.component.scss']
})
export class EditableTaskComponent implements OnInit {
  @Input() facturerData = {};//厂商
  @Input() sendOrderData;//厂务工程师
  @Input() formid = "";
  @Input() projectItemInfo = {};
  @Input() taskAssignDisabled: boolean;
  @Input() vendorTaskAssignEdictStatus = false;
  @Input() engineerTaskAssignEdictStatus = false;
  @Input() vendorInfoData;
  @Input() electromechanicalData = [];
  @Input() civilVendorInfoData = [];
  @Input() electromechanical: boolean;
  @Input() civilEngineering: boolean;
  @Output() submitTaskAssignDataEvent = new EventEmitter<object>();

  tableTitle = [...TASK_ASSIGN_EDIT_TABLE];
  sendOrderChecked = -1;
  activeTable = {
    "civil": true,
    "electro": true,
  };
  submitTaskAssignData = {
    "signData": {},
    "assignEngineer": {},
    "projectSort": {
      "formId": '',
      "civilEngineering": 0,
      "electromechanical": 0
    },
    "civilEngineering": {},
    "electromechanical": {},
    "vendorInfoOption": {
      "civilfacture": {},
      "electrofacture": {}
    }
  }
  item = {
    "civil": "",
    "electro": ""
  }

  facturerDataCheck = {
    "civil": -1,
    "electro": -1
  };

  projectData: string;
  civlOrElectroInfo = [];

  constructor(
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    // do something
  }

  ngOnChanges(changes: SimpleChanges) {
    this.civlOrElectroInfo = [];
    if (!!this.civilEngineering) {
      this.civlOrElectroInfo.push({ "text": this.translateService.instant('DetailInfo.CIVIL'), "value": "civil" });
    }
    if (!!this.electromechanical) {
      this.civlOrElectroInfo.push({ "text": this.translateService.instant('DetailInfo.ELECTRO'), "value": "electro" });
    }
    this.getInitHistoryData();
  }

  //勾选的工程分细项-土建 工程分细项-机电 派单厂务工程师 土建厂商 机电厂商
  nzSendOrderRadioChange(value: any, name: string, type?: string, check?: boolean) {
    // 工程分类明细
    if (name === "projectItemInfo") {
      // 修改后或未修改的工程分类
      this.submitTaskAssignData['projectSort'].formId = this.formid;
      let tempProjectItem: ProjectItemOption = {};
      tempProjectItem.formId = this.formid;
      tempProjectItem.civilOrEleco = type === 'civil' ? this.translateService.instant('DetailInfo.CIVIL') : this.translateService.instant('DetailInfo.ELECTRO');
      this.submitTaskAssignData['projectSort'].civilEngineering = !!this.civilEngineering ? 1 : 0;
      this.submitTaskAssignData['projectSort'].electromechanical = !!this.electromechanical ? 1 : 0;
      if (type === 'civil') {
        this.submitTaskAssignData['civilEngineering'] = tempProjectItem;
      } else {
        this.submitTaskAssignData['electromechanical'] = tempProjectItem;
      }

      // 选择的工程分类明细check状态,true为选中,false为未选中
      this.projectItemInfo[type] = this.projectItemInfo[type].map(element => {
        if (element['middleType'] === value) {
          element['check'] = !!check ? check : !element['check'];
          if (element['check']) {//如果check=true
            if (!(this.item[type].includes(value))) {//如果没有重复,则添加到this.item[type]中,如果重复,则不作处理
              this.item[type] = this.item[type] === '' ? value : this.item[type] + ',' + value;
            }
            tempProjectItem.projectItemInfo = this.item[type];
          }
          else {
            // 如果this.item[type]中已经包含有value,则删除value
            if (this.item[type].includes(value) === true) {
              // 如果this.item[type]中包含'value,',则删除,否则只删除value
              if (this.item[type].includes(value + ',')) {
                let delValue = value.concat(',');
                let itemDel = this.item[type].replace(delValue, '');
                this.item[type] = itemDel;
              } else {
                this.item[type] = this.item[type].replace(value, '');
              }
              tempProjectItem.projectItemInfo = this.item[type];
            } else {
              this.item[type] = '';
              tempProjectItem.projectItemInfo = this.item[type];
            }
          }
        }
        return element;
      });
    }
    // 厂务工程师
    else if (name === "sendOrderData") {
      const temp = this.sendOrderData.filter(ele => ele['assignEmplid'] === value)[0];
      delete temp['id'];
      this.submitTaskAssignData['assignEngineer'] = temp;
    }
    // 厂商
    else if (name === "facturerData") {
      this.facturerData[type].forEach(obj => {
        if (obj.vendorCode === value) {
          let tempData = {
            formId: obj['formId'],
            vendorCode: obj['vendorCode'],
            vendor: obj['cicivlOrElectro'],
            facturer: obj['facturer'],
            professional: obj['technical'],
            contact: obj['contact'],
            tel: obj['tel'],
            email: obj['email'],
            issuedBid: obj['issuedBid'],
            issuedBidTotal: obj['issuedTotal'],
            issuedBidOverTime: obj['issuedBidOverTime'],
            issuedBidOverTimeTotal: obj['issuedBidOverTimeTotal'],
            notCooperateBids: obj['notCooperateBids'],
            notCooperateBidsTotal: obj['notCooperateBidsTotal'],
            waitBidNumbers: obj['waitBidNumbers'],
          };
          if (type === 'civil') {
            this.submitTaskAssignData['vendorInfoOption']['civilfacture'] = tempData;
          }
          else {
            this.submitTaskAssignData['vendorInfoOption']['electrofacture'] = tempData;
          }
        }
      });
    }
    this.submitTaskAssignDataEvent.emit(this.submitTaskAssignData);
  }

  // 获取DB中的历史数据
  getInitHistoryData() {
    if (this.vendorInfoData) {
      // 厂务工程师
      if (JSON.stringify(this.vendorInfoData['assignInfo']) !== '{}') {
        this.sendOrderData.forEach(element => {
          if (element['assignEmplid'] === this.vendorInfoData['assignInfo']['assignEmplid']) {
            this.sendOrderChecked = element['assignEmplid'];
            this.nzSendOrderRadioChange(element['assignEmplid'], 'sendOrderData');
          }
        });
      }

      // 工程分类明细
      this.civlOrElectroInfo.forEach(obj => {
        this.submitTaskAssignData['projectSort'].formId = this.formid;
        if (obj['value'] === 'civil') {
          this.submitTaskAssignData['projectSort'].civilEngineering = 1;
        } else {
          this.submitTaskAssignData['projectSort'].electromechanical = 1;
        }
        this.submitTaskAssignDataEvent.emit(this.submitTaskAssignData);
        if (this.vendorInfoData['projectItemInfo'] !== undefined) {
          if (JSON.stringify(this.vendorInfoData['projectItemInfo'][obj['value']]) != '{}') {
            if (!!this.projectItemInfo[obj['value']]) {
              this.projectItemInfo[obj['value']] = this.projectItemInfo[obj['value']].map(element => {
                // 如果在vendorInfoData中没有找到与element['middleType']匹配,则返回-1
                if (this.vendorInfoData['projectItemInfo'][obj['value']]['projectItemInfo'].indexOf(element['middleType']) > -1) {
                  this.nzSendOrderRadioChange(element['middleType'], 'projectItemInfo', obj['value'], true);
                } else {
                  element['check'] = false;
                }
                return element;
              });
            }
          }
        }
      });

      // 选择厂商
      if (JSON.stringify(this.facturerData) !== '{}' && this.vendorInfoData['vendorInfoo'].length > 0) {
        const vendorObj = {};
        this.vendorInfoData['vendorInfoo'].forEach(vendorItem => {
          if (vendorItem['civilOrElectro'] === 0) {
            vendorObj['civil'] = {
              vendorCode: vendorItem['vendorCode']
            }
          }
          else {
            vendorObj['electro'] = {
              vendorCode: vendorItem['vendorCode']
            }
          }
        });
        Object.keys(this.facturerData).forEach(key => {
          if (!!this.facturerData[key] && !!vendorObj[key]['vendorCode']) {
            for (let item of this.facturerData[key]) {
              if (item['vendorCode'] === vendorObj[key]['vendorCode']) {
                this.facturerDataCheck[key] = item['vendorCode'];
                this.nzSendOrderRadioChange(item['vendorCode'], 'facturerData', key);
              }
            }
          }
        });
      }
    }
  }
}
